import { nonEmptyString } from '~/schema/validators';

const validation = {
  name: nonEmptyString,
  description: nonEmptyString,
};

export default validation;
